<template>
	<div :class="currentStyles.contentWrapper">
		<div :class="currentStyles.content">
			<span :class="currentStyles.subHeading">
				{{ blok.sub_heading }}
			</span>

			<div :class="currentStyles.text">
				<StoryblokComponent
					v-for="heading in blok.heading"
					:key="heading._uid"
					:blok="heading"
				/>
			</div>
			<StoryblokComponent
				v-for="call_to_action in blok.call_to_action"
				:key="call_to_action._uid"
				:blok="call_to_action"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { BlokHero } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokHero;
	stylesType: "default" | "proportional";
	isSwiper?: boolean;
	isCategory?: boolean;
}
const { blok, stylesType, isSwiper, isCategory } = defineProps<Props>();

const blockStyles = {
	default: {
		contentWrapper: `${blok.height} flex flex-col ${blok.content_align} container mx-auto absolute inset-0 ${blok.opacity || ""}`,
		content:
			"w-full flex flex-col justify-center items-center pb-12 text-white gap-4",
		text: "text-4xl font-extralight text-center",
		subHeading: "text-base"
	},
	proportional: {
		contentWrapper: `absolute h-full w-full z-[1] ${blok.opacity || ""}`,
		content: `absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 w-full ${isSwiper ? "xl:max-w-[35%] max-w-[70%] md:px-8 px:0" : isCategory ? "max-w-full px-5" : "max-w-[75%] px-8"} text-center text-base`,
		text: "banner-text mb-1.25",
		subHeading: ""
	}
};

const currentStyles = computed(() => blockStyles[stylesType]);
</script>
